import React, { useContext } from 'react';

import { SimilarJobsContext } from '@/contexts';
import { HtmlDescription } from '@/graphql/generated';

import SimilarJobsSidebar from './components/similar-jobs-sidebar';
import { useVideoReplace } from './use-video-replace';
import withShowMoreInMobile from './withShowMoreInMobile';

import * as S from './html-description-component.styles';

import './html-template/job-description-template.css';

interface Props {
  description: HtmlDescription;
  hasTrackingConsent: boolean;
}

export const HTMLDescriptionComponent: React.VFC<Props> = withShowMoreInMobile(
  ({ description, hasTrackingConsent }: Props) => {
    const { loading, hasSidebarJobs, sidebarJobs } = useContext(SimilarJobsContext);

    const showSimilarJobsSideBar = hasSidebarJobs && (loading || !!sidebarJobs?.length);
    const replacedContent = useVideoReplace(description.content);

    return (
      <>
        <S.StyledColumn size={12} sizeWide={showSimilarJobsSideBar ? 8 : 12}>
          <S.StyledHeader
            dangerouslySetInnerHTML={{
              __html: hasTrackingConsent ? description.content || '' : replacedContent,
            }}
          />
        </S.StyledColumn>
        {showSimilarJobsSideBar && <SimilarJobsSidebar similarJobs={{ loading, data: sidebarJobs }} />}
      </>
    );
  }
);
